import _extends from 'babel-runtime/helpers/extends';

export default {
  name: 'PmTeamsSelector',

  componentName: 'PmTeamsSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    pmTeams: function pmTeams() {
      return this.$store.state.options.pmTeams;
    },
    innerConfig: function innerConfig() {
      var params = _extends({
        clearable: true,
        placeholder: '请选择PM团队'
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  mounted: function mounted() {
    if (this.pmTeams && !this.pmTeams.length) {
      this.$store.dispatch('GetPmTeams');
    }
  }
};